import React, { Component } from 'react'
import { connect } from 'react-redux'
import ReactTable from 'react-table'
import { browserHistory } from 'react-router'

import { getGameList } from '../actions/playerActions'
import { AxiosProvider, Request, Get } from 'react-axios'

import { Position, Toaster } from '@blueprintjs/core'

import "react-table/react-table.css"

let generate = require('project-name-generator')
let uuidv1 = require('uuid/v1')
let axios = require('axios')

/*const API_BASE_URL = 'https://en605401.jamalmahboob.com:5000'
const dev_API_BASE_URL = 'http://10.0.0.29:5000'*/
const LobbyToaster = Toaster.create({
    className: 'playerTokenToaster',
    position: Position.BOTTOM_RIGHT
})

class Lobby extends Component {
    constructor(props) {
        super(props)
        this.state = {
            data: [] 
        }
    }

    joinGame = (gameid) => {
        console.debug(gameid)
        //browserHistory.push('/game/' + gameid)
        axios.get(process.env.REACT_APP_API + '/api/game/' + gameid + '/joingame', {withCredentials: true})
            .then( (response) => {
                browserHistory.push('/game/' + gameid)
            })
            .catch( (error) => {
                browserHistory.push('/game/' + gameid)
            })
    }

    createGame = () => {
        let data = JSON.parse(JSON.stringify(this.state.data))
        /*let newGame = {
            name: generate().spaced.replace(' ', '').toUpperCase() ,
            gameid:  uuidv1()
        }*/
        axios.get(process.env.REACT_APP_API + '/api/creategame')
            .then((response) => {
                data.push(response.data)
                LobbyToaster.show({
                    message: JSON.stringify(response.data)
                })
                this.setState({
                    data: data
                })
            })    
        //data.push(newGame)
    }

    componentDidMount() {
        axios.get(process.env.REACT_APP_API + '/api/gamelist')
            .then((response) => {
                console.debug(response)
                this.setState({
                    data: response.data
                })
            })
    }

    render() {
        let columns = [
            {
                Header: "Name",
                accessor: "name"
            },
            {
                Header: "ID",
                accessor: "gameid"
            },
            {
                Header: "Play",
                accessor: "gameid",
                Cell: row => (
                    <button className="pt-button pt-dark" onClick={(gameid) => this.joinGame(row.value)}>
                        Join Game
                    </button>
                )
            }
        ] 

        return (
            <div className='center-center'>
                <div>
                    <button className='pt-button pt-dark' onClick={() => this.createGame()}>
                        Create Game
                    </button>
                </div>
                <div>
                    <ReactTable 
                        defaultPageSize={5}
                        data={this.state.data} 
                        columns={columns}/>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
    }
}

export default connect(mapStateToProps)(Lobby)



// WEBPACK FOOTER //
// ./src/routes/Lobby.jsx